import { Inertia } from "@inertiajs/inertia";

export default class BrowserStorage {
    constructor(obj) {

        // Data given server side from browser session storage facade
        this.tab_id = obj.tab_id;
        this.session_path = obj.session_path;
        this.browser_session_storage_path = obj.browser_session_storage_path;
        this.rules = obj.rules;
        this.sync_route = obj.sync_route;
        this.query_parameter = obj.query_parameter;
        this.tmp_uuid = obj.tmp_uuid;

        // Enable sync data
        this.sync(true);

        // console.log("TAB_ID", this.tab_id);
        // console.log("SESSION_STORAGE_TAB_ID", this.storageTabId);
        // console.log("TAB_ID_GENERATED", this.tab_id_generated);
        // console.log("TAB_DATA", _.get(obj, 'data.' + this.storageTabId));

        // Model data + load from tab session storage
        this.data = { ...obj.data, ...this.fromStorage };
    }

    static make(data) {
        return new this(data);
    }

    get tabIdDifferent() {
        return this.tab_id !== this.storageTabId;
    }

    get missingQueryParam() {
        const t = new URLSearchParams(window.location.search).get('t');
        return !t || !t.length;
    }

    inertiaReload() {
        if (!this.missingQueryParam && !this.tabIdDifferent) {
            return;
        }
        this.loadTabId();
        // console.log("Reload with tab_id", this.tab_id);
        Inertia.reload({
            data: { [this.query_parameter]: this.tab_id },
            replace: true,
        });
    }

    setTabIdFromTmpUuid() {
        this.tab_id = this.tmp_uuid;
        sessionStorage.setItem('tab_id', this.tmp_uuid);
        return this;
    }

    setTabIdFromStorage() {
        this.tab_id = sessionStorage.getItem('tab_id');
        return this;
    }

    loadTabId() {
        if (this.storageTabId) {
            return this.setTabIdFromStorage();
        }
        return this.setTabIdFromTmpUuid();
    }

    putStorage() {
        sessionStorage.setItem(
            this.browser_session_storage_path,
            JSON.stringify(this.data)
        );
        return this;
    }

    get fromStorage() {
        return JSON.parse(
            sessionStorage.getItem(this.browser_session_storage_path)
        );
    }

    get(key) {
        return _.get(this.data, key);
    }

    set(key, value) {
        _.set(this.data, key, value);
        return this.updated();
    }

    setData(value) {
        this.data = value;
        return this.updated();
    }

    updated() {
        return this
            .putStorage();
    }

    sync(bool = true) {
        this.sync_enabled = bool;
        return this;
    }

    syncToServer() {
        if (!this.sync_enabled) {
            return new Promise;
        }
        // console.log("Start sync", this.data);
        return axios.post(this.sync_route, {
            tab_id: this.tab_id,
            data: this.data,
        }).then(function (response) {
            // console.log("Synced", response);
        }).catch(function (error) {
            console.log("Browser session sync error", error);
        });
    }

    get storageTabId() {
        return sessionStorage.getItem('tab_id');
    }
}
